module.exports = __webpack_public_path__ + "img/1-1.af8bdfd6.jpg";